import { AdaptedGoalTransferDTO } from '@/domain/transfer'

/**
 * Adds date headers to transactions by comparing dates between consecutive transactions
 * Similar to transactionsWithDateHeaders from React Native version
 */
export const addDateHeadersToTransactions = (
  transactions: AdaptedGoalTransferDTO[],
): AdaptedGoalTransferDTO[] => {
  return (
    transactions?.map((transaction, index, list) => {
      const previousTransaction = list[index - 1]
      const isDifferentDay =
        !previousTransaction ||
        transaction.created_at.toDateString() !==
          previousTransaction.created_at.toDateString()

      return {
        ...transaction,
        isDifferentDay,
      }
    }) || []
  )
}
